import request from '@/utils/request'

// 获取消息列表
export function notificationList(params = {}) {
  return request({
    url: `/web_notification/list`,
    method: 'get',
    params
  })
}

// 标记已读
export function notificationReaded(data) {
  return request({
    url: '/web_notification/read',
    method: 'post',
    data
  })
}

// 删除消息
export function delNotification(data) {
  return request({
    url: '/web_notification/destroy',
    method: 'post',
    data
  })
}

// 消息统计
export function notificationStatistics() {
  return request({
    url: `/web_notification/statistics`,
    method: 'get'
  })
}
// 订单列表
export function adqorderlist(params = {}) {
  return request({
    url: `/ad_management/adq_report/order_list`,
    method: 'get',
    params
  })
}
// 回传订单
export function adqmanualback(data) {
  return request({
    url: '/ad_management/adq_report/manual_back',
    method: 'post',
    data
  })
}

// 投放位置列表
export function placementList(params = {}) {
  return request({
    url: '/iaaMaterialReport/position/index',
    method: 'get',
    params
  })
}

// 投放位置列表（根据投手ID）
export function placementListByPitcher(params = {}) {
  return request({
    url: '/iaaMaterialReport/position/list',
    method: 'get',
    params
  })
}

// 创建投放位置
export function placementCreate(data = {}) {
  return request({
    url: '/iaaMaterialReport/position/create',
    method: 'post',
    data
  })
}

// 更新投放位置
export function placementUpdate(data = {}) {
  return request({
    url: '/iaaMaterialReport/position/update',
    method: 'post',
    data
  })
}

// 删除投放位置
export function placementDelete(data = {}) {
  return request({
    url: '/iaaMaterialReport/position/destroy',
    method: 'post',
    data
  })
}

// 投手账户列表
export function pitcherAccountList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/pitcherAccount',
    method: 'get',
    params
  })
}

// 广告状态列表
export function promotionsList(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/promotions',
    method: 'get',
    params
  })
}

// 关闭广告
export function closeAd(data) {
  return request({
    url: '/iaaMaterialReport/report/closeAd',
    method: 'post',
    data
  })
}

// 获取广告主所有计划和项目
export function getAllPromotions(params = {}) {
  return request({
    url: '/iaaMaterialReport/report/getAllPromotions',
    method: 'get',
    params
  })
}
